import { PaymentPlanStatusEnum, PaymentPlanTypeEnum, ProductPaymentPlan } from '@bondsports/types';
import { ResourceInterface } from './resources';
import { RepetitionUnit } from '@bondsports/date-time';

export enum AddonRelationType {
	CHILD = 'child',
	UPSALE = 'upsale',
}
export enum ProductSubTypesEnum {
	// league season registartion type
	SEASON_INDIVIDUAL = 'season_individual',
	SEASON_TEAM = 'season_team',
	SEASON_PER_PLAYER = 'season_per_player',
}

export interface ProductPrice {
	id: number;
	createdAt: string;
	updatedAt: string;
	organizationId: number;
	productId: number;
	name: string;
	price: number;
	currency: string;
	// paymentProcessorId: string;
	startDate: string;
	endDate: string;
	originalPrice?: number;
}

export interface ISchedulePaymentPlan {
	id: number;
	createdAt: string;
	updatedAt: string;
	organizationId: number;
	paymentPlanId: number;
	paymentDate: string;
	fixed?: number;
	percent?: number;
	deletedAt?: string;
}

export interface IPaymentPlan {
	id: number;
	createdAt: string;
	updatedAt: string;
	organizationId: number;
	productId: number;
	dayOfMonth?: number | string;
	name: string;
	deletedAt?: string;
	schedule?: ISchedulePaymentPlan[];
	startsInMonths?: number;
	installmentRepeat?: RepetitionUnit;
	status: PaymentPlanStatusEnum;
	paymentPlanType: PaymentPlanTypeEnum;
	maxInstallments?: number;
}

export interface IResourceSettings {
	createdAt: string;
	deletedAt: string | null;
	entityId: number;
	entityType: string;
	id: number;
	key: string;
	organizationId: number;
	updatedAt: string;
	value: string;
}

export interface Product {
	id: number;
	organizationId?: number;
	name: string;
	tax: number;
	isTaxInclusive: boolean;
	quantity: number;
	startDate?: string;
	endDate?: string;
	description?: string;
	prices?: ProductPrice[];
	currPrice: ProductPrice;
	downpayment?: number;
	isProRated?: boolean;
	productSubType?: ProductSubTypesEnum;
	punchCard: boolean;
	resources?: ResourceInterface;
	requiredProductIds?: number[];
	productPaymentPlan?: IPaymentPlan;
	defaultPrice: ProductPrice;
	isAll?: boolean;
	resourceSettings?: IResourceSettings[];
	productPaymentPlans?: ProductPaymentPlan[];
}

export interface ProductPackageChild {
	product: Product;
	relationType: AddonRelationType;
}

// the children of a product
export interface ProductPackage {
	parentProduct: Product;
	children: ProductPackageChild[];
}

export enum ProductSettingsKeysEnum {
	IS_MULTIPLE_QUANTITIES_PURCHASE_ALLOWED = 'isMultipleQuantitiesPurchaseAllowed',
	IS_HIDE_ALL_QUANTITY_SCHEDULE = 'isHideAllQuantitySchedule',
	IS_HIDE_PUNCHPASS_SCHEDULE = 'isHidePunchPassSchedule',
}
